import React, {FC} from 'react';
import {
	Box,
	Button,
	Modal,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalOverlay,
	Popover,
	PopoverArrow,
	PopoverBody,
	PopoverCloseButton,
	PopoverContent,
	PopoverProps,
	PopoverTrigger,
	useDisclosure,
	useMediaQuery,
} from 'components/ui/chakra';

interface MobilePopoverProps extends PopoverProps {
	triggerElement: React.ReactNode;
	children: React.ReactNode;
}

const MobilePopover: FC<MobilePopoverProps> = ({triggerElement, children, ...popoverProps}) => {
	const [isLargerThan800] = useMediaQuery('(min-width: 800px)');
	const {isOpen, onOpen, onClose} = useDisclosure();

	return isLargerThan800 ? (
		<Popover {...popoverProps}>
			<PopoverTrigger>{triggerElement}</PopoverTrigger>
			<PopoverContent>
				<PopoverArrow />
				<PopoverCloseButton />
				<PopoverBody>{children}</PopoverBody>
			</PopoverContent>
		</Popover>
	) : (
		<>
			<Box role='button' onClick={onOpen}>
				{triggerElement}
			</Box>
			<Modal isCentered isOpen={isOpen} size='sm' onClose={onClose}>
				<ModalOverlay />
				<ModalContent>
					<ModalBody py={4}>{children}</ModalBody>
					<ModalFooter>
						<Button colorScheme='blue' onClick={onClose}>
							Close
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	);
};

export default MobilePopover;
